// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";
import anime from 'animejs/lib/anime.es.js';
import waypoint from 'waypoints/lib/jquery.waypoints.js';

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";

const $ = jQuery;

$( () => {

// const animationElement = document.querySelector('.lottie-top-container');
// const wrapperElement = document.querySelector('.lottie-wrapper');

// if (animationElement) {
//   // Load the Lottie animation
//   const animation = lottie.loadAnimation({
//     container: animationElement,
//     renderer: 'svg',
//     loop: true,
//     autoplay: true,
//     path: 'app/themes/default/dist/images/stripe-2.json',
//   });
//   animation.setSpeed(10);
// }




  //partners carousel buttons
    // function myFunction(x) {
    //   if (x.matches) { // If media query matches
    //     $('.home-partner-panel button.logo-slider-nav').prependTo('.bx-wrapper');
    //   } 
    // }
    
    // var x = window.matchMedia("(min-width: 1200px)")
    // myFunction(x) // Call listener function at run time
    // x.addListener(myFunction) // Attach listener function on state changes

    // Select all elements with class "home-partner-panel"
    var panels = $('.home-partner-panel');

    // Iterate through each panel
    panels.each(function () {
    // Select the buttons within the current panel
    var button1 = $(this).find('button.logo-slider-nav.logo-slider-prev');
    var button2 = $(this).find('button.logo-slider-nav.logo-slider-next');

    // Swap the buttons within the current panel
    button1.insertBefore(button2);
    });





  $( 'form.af-form' ).each( function ( this: HTMLFormElement ) {
    new AdvancedForm( this );
  } );

  //add span in seige button
  $('li.siege-btn a').wrapInner('<span></span>');
  

  document.documentElement.style.setProperty( '--scrollbar-width', getScrollbarWidth() + 'px' );

  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $( '.gallery a.thumbnail' ).fluidbox();
  $( '.gallery a.thumbnail img' ).each( function ( this: HTMLImageElement ) {
    if ( this.src !== this.getAttribute( 'src' ) ) {
      $( this ).replaceWith( $( this.outerHTML ) );
    }
  } );

  // flyout menu
  $( '.navbar-collapse.width' ).on( 'show.bs.collapse hide.bs.collapse', function ( e ) {
    $( 'body' ).toggleClass( 'menu-visible' );
  } );

  $('.logo-image-wrapper').addClass('has-corner-border');
  $('.home-certi-panel .fl-photo-content').addClass('has-corner-border');
  $('.home-say-panel .pp-testimonials-content').addClass('has-corner-border white');

  $('pp-accordion-button-icon').addClass('has-corner-border');
  $('.contact-warning-panel h6.fl-heading').addClass('has-corner-border red');
  $('.pp-accordion-button-icon').addClass('has-corner-border');
  

  var span1 = $("<span>").addClass("top-corner");
  var span2 = $("<span>").addClass("bottom-corner");
  var span3 = $("<span>").addClass("line");

  // Add the new span elements to the div with id "myDiv"
  $("#price-list .pp-pricing-table-column").addClass("has-corner-border white");
  $(".has-corner-border").prepend(span1);
  $(".has-corner-border").append(span2);

  $(".has-corner-border.animation-item").append(span3);

  $("li.contact-us a.nav-link").contents().wrap("<span></span>");
  $("li.contact-us a.nav-link").addClass("btn siege-btn");
  $('.button-list label').contents().wrap("<span></span>");



    // Add custom icons to Max Mega Menu submenus
    $('li.mega-menu-item.mega-menu-item-type-taxonomy ul.mega-sub-menu > li').each(function() {
        var menuItem = $(this);
        
        // Retrieve the iconClass from the <li> element's classes
        var classes = menuItem.attr('class').split(' ');
        var iconClass = '';
        classes.forEach(function(className) {
        if (className.startsWith('fa-')) {
            iconClass = className;
            return false; // Exit the loop after finding the iconClass
        }
        });
        
        // Prepend the icon to the <li> element
        menuItem.prepend('<i class="menu-item-icon fa-regular fa-lg ' + iconClass + '"></i>');
    });

  
  
    

    
  
    



    // Get the current page URL
    var currentURL = window.location.href;
  
    // Check if the URL contains the target page path
    if (currentURL.indexOf('/category/blog/') > -1) {
      // Add the active class to the button
      $('.btn.siege-btn.siege-btn-gray.blog').addClass('active');
    }


    // if (window.location.href.indexOf('/category/blog/?_categories=') !== -1) {
    //   var categoryName = window.location.href.split('/category/blog/?_categories=')[1];
    //   if (categoryName) {
    //     $('a.btn.siege-btn.siege-btn-gray.blog').removeClass('active');
    //   } else {
    //     $('a.btn.siege-btn.siege-btn-gray.blog').addClass('active');
    //   }
    // }


    // document.addEventListener('DOMContentLoaded', () => {
    //   $('.animation-container').each(function() {
    //     var waypoint = new Waypoint({
    //       element: this,
    //       handler: function(direction) {
    //         initDesktop();
    //       },
    //       offset: -250
    //     });
    //   });

    // });
    



    
    
    
    

//   initDesktop();
//   function initDesktop() {
//     var duration = 500;
//     var delta = 1500;
//     var slides = document.querySelectorAll('.animation-item');


//     //total duration of animation 
//     var animationDuration = duration + slides.length * duration + ((slides.length - 1) * delta);

//     slides.forEach(function(slide, index) {
//       //computer delay before begin to animate a specific slide
//       var topCorner = slide.querySelector('.top-corner');
//       var bottomCorner = slide.querySelector('.bottom-corner');
//       var line = slide.querySelector('.line');
//       var begin = duration + (index * duration) + (index * delta);
//       //attribute z-index
//       //slide.style.zIndex = slides.length - index;
//       //create animjs timeline
//       var tm = anime.timeline({autoplay: true});
//       //add first animation : slide to right
//       tm.add({
//         targets: slide,
//         opacity: [0, 1],
//         duration: duration,
//         easing: 'linear',
//         delay: begin,
//       }).add( {
//         targets: [topCorner, bottomCorner],
//         opacity: [0, 1],
//         duration: 100,
//         easing: 'linear'
//       }).add({
//         targets: [topCorner, bottomCorner],
//         opacity: 0,
//         duration: 100,
//         easing: 'linear'
//       }).add({
//         targets: [topCorner, bottomCorner],
//         opacity: 1,
//         duration: 100,
//         easing: 'linear'
//       }).add({
//         targets: line,
//         opacity: [0, 1],
//         duration: 300,
//         easing: 'linear'
//       });

//     }); 
// }





/* ---- particles.js config ---- */
var particleConfigs = {
  "particles": {
    "number": {
      "value": 120,
      "density": {
        "enable": true,
        "value_area": 600
      }
    },
    "color": {
      "value": "#ffffff"
    },
    "shape": {
      "type": "circle",
      "stroke": {
        "width": 0,
        "color": "#000000"
      },
      "polygon": {
        "nb_sides": 5
      },
      "image": {
        "src": "img/github.svg",
        "width": 100,
        "height": 100
      }
    },
    "opacity": {
      "value": 0.5,
      "random": false,
      "anim": {
        "enable": false,
        "speed": 1,
        "opacity_min": 0.1,
        "sync": false
      }
    },
    "size": {
      "value": 3,
      "random": true,
      "anim": {
        "enable": false,
        "speed": 30,
        "size_min": 0.1,
        "sync": false
      }
    },
    "line_linked": {
      "enable": true,
      "distance": 150,
      "color": "#ffffff",
      "opacity": 0.3,
      "width": 1
    },
    "move": {
      "enable": true,
      "speed": 2,
      "direction": "none",
      "random": false,
      "straight": false,
      "out_mode": "out",
      "bounce": false,
      "attract": {
        "enable": false,
        "rotateX": 600,
        "rotateY": 1200
      }
    }
  },
  "interactivity": {
    "detect_on": "canvas",
    "events": {
      "onhover": {
        "enable": false,
        "mode": "grab"
      },
      "onclick": {
        "enable": false,
        "mode": "push"
      },
      "resize": true
    },
    "modes": {
      "grab": {
        "distance": 140,
        "line_linked": {
          "opacity": 1
        }
      },
      "bubble": {
        "distance": 400,
        "size": 40,
        "duration": 2,
        "opacity": 8,
        "speed": 3
      },
      "repulse": {
        "distance": 200,
        "duration": 0.4
      },
      "push": {
        "particles_nb": 4
      },
      "remove": {
        "particles_nb": 2
      }
    }
  },
  "retina_detect": true
};

function initializeParticles() {
  var particleElements = document.querySelectorAll('[id^="particles-js"]');
  particleElements.forEach(function(element) {
    particlesJS(element.id, particleConfigs);
  });
}

// Call the function on page load
window.addEventListener('load', initializeParticles);

// Call the function on window resize
window.addEventListener('resize', initializeParticles);





let constrain = 200;
let rotationFactor = 5; // Increase this value to amplify the rotation
let transitionTime = 0.5; // Increase the transition time to 0.5s
let containers = document.querySelectorAll(".ex1");

function transforms(x, y, el) {
  let box = el.getBoundingClientRect();
  let calcX = -(y - box.y - (box.height / 2)) / constrain * rotationFactor; // Amplify rotation
  let calcY = (x - box.x - (box.width / 2)) / constrain * rotationFactor; // Amplify rotation

  return "perspective(100px) "
    + "rotateX(" + calcX + "deg) "
    + "rotateY(" + calcY + "deg)";
}

function transformElement(el, xyEl) {
  el.style.transition = "transform " + transitionTime + "s"; // Update transition time
  el.style.transform = transforms.apply(null, xyEl);
}

containers.forEach(function(container) {
  let mouseOverContainer = container;
  let ex1Layer = container.querySelector(".ex1-layer");

  mouseOverContainer.addEventListener("mouseenter", function(e) {
    ex1Layer.style.transition = "transform " + transitionTime + "s"; // Update transition time
  });

  mouseOverContainer.addEventListener("mouseleave", function(e) {
    ex1Layer.style.transition = "transform " + transitionTime + "s"; // Update transition time
    ex1Layer.style.transform = "perspective(100px) rotateX(0deg) rotateY(0deg)";
  });

  mouseOverContainer.addEventListener("mousemove", function(e) {
    let xy = [e.clientX, e.clientY];
    let position = xy.concat([ex1Layer]);

    window.requestAnimationFrame(function() {
      transformElement(ex1Layer, position);
    });
  });
});







} );
